/** @format */
import { createSlice } from "@reduxjs/toolkit";
import { initialState } from "./state.ts";
import { updateStorage } from "../../utilities/setting.js";
import _ from "lodash";

// const createAuthObj = (state) => {
//   return {
//     saveLocal: state.saveLocal,
//     storeKey: state.storeKey,
//     session: _.cloneDeep(state.session),
//   };
// };

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    signInSuccess(state, action) {
      state.signedIn = "true";
      state.token = action.payload;
    },
    signOutSuccess(state) {
      state.signedIn = "false";
      state.token = null;
    },
    setRefreshToken(state, action) {
      state.refresh_token = action.payload;
    },
  },
});

export const { signInSuccess, signOutSuccess, setRefreshToken } =
  authSlice.actions;
export default authSlice.reducer;
